import { useShallow } from 'zustand/shallow';
import { CandidatesStore, store } from './store';

export const useCandidates = () => {
  const {
    _ids,
    data,
    count,
    loading,
    error,
    summary,
    goToStage,
    updateCandidate,
    areDefaultFiltersActive,
    resetFilters,
    updateFilters,
    hasActiveFilters,
    updatePagination,
    updateSort,
    params,
    moveToStage,
    contactExport,
    updateCandidateRating,
    loadingSpinner,
    reset,
    exportCandidatesToCopilot,
  } = store<CandidatesStore>(
    useShallow((state) => ({
      _ids: state._ids,
      data: state.data,
      count: state.count,
      loading: state.loading,
      loadingSpinner: state.loadingSpinner,
      error: state.error,
      params: state.params,
      summary: state.summary,
      goToStage: state.goToStage,
      paramsByStage: state.paramsByStage,
      fetchCandidates: state.fetchCandidates,
      updateCandidate: state.updateCandidate,
      areDefaultFiltersActive: state.areDefaultFiltersActive,
      resetFilters: state.resetFilters,
      updateFilters: state.updateFilters,
      updatePagination: state.updatePagination,
      updateSort: state.updateSort,
      updateQueryParams: state.updateQueryParams,
      moveToStage: state.moveToStage,
      exportCandidatesToCopilot: state.exportCandidatesToCopilot,
      contactExport: state.contactExport,
      updateCandidateRating: state.updateCandidateRating,
      hasActiveFilters: state.hasActiveFilters,
      reset: state.reset,
    })),
  );

  //? Purposefully not exposing `state.fetchCandidates` & `paramsByStage`
  return {
    _ids,
    data,
    count,
    loading,
    loadingSpinner,
    reset,
    error,
    summary,
    params,
    hasActiveFilters,
    goToStage,
    updateCandidate,
    areDefaultFiltersActive,
    resetFilters,
    updateFilters,
    updatePagination,
    updateSort,
    moveToStage,
    contactExport,
    updateCandidateRating,
    exportCandidatesToCopilot,
  };
};
